import {UserIncident} from "../../../../domain/incident/Incident";
import React, {FC} from "react";

type Props = {
    item: UserIncident;
};

export const IncidentRowType: FC<Props> = ({item}) => {
    const {type} = item;
    return (
        <div className={"m-0 p-0 flex flex-row flex-wrap gap-2"}>
            <span className={"text-neutral-400 font-semibold"}>TIPO</span>
            <span>{type}</span>
        </div>
    );
};
